import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import SubText from '../../../../../shared/_TBComponents/SubText';
import LoginFormSSO from './LoginFormSSO';
import Logo from '../../../../../shared/images/full-logo-black-orange.png';
import Text from '../../../../../shared/_TBComponents/Text';

const CheckEmailContainer = styled('div')`
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  padding: 60px 48px;
  text-align: center;
  width: 440px;
`;

const FormContainer = styled('div')`
  width: 430px;
  height: auto;
  background-color: white;
  padding-bottom: 40px;

  @media screen and (max-width: 600px) {
    width: 330px;
    height: auto;
    padding-bottom: 20px;
  }
`;

const TitleArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 2px solid rgb(232, 232, 232);
  height: 160px;
  align-items: center;
  padding: 30px 80px 5px 80px;
  justify-content: center;

  img {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 600px) {
    height: 135px;
  }
`;

const FormArea = styled('div')`
  padding: 30px 54px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 30px;
  }
`;

const LoginFormContainerSSO = () => {
  const emailAddress = useSelector((state) => state.auth.data.emailAddress);
  const isPasswordNeeded = useSelector((state) => state.auth.data.isPasswordNeeded);

  if (isPasswordNeeded) {
    return (
      <CheckEmailContainer>
        <Text
          styledTextProps={{
            fontSize: '34px',
            fontWeight: '700',
          }}
        >
          Check your email to set a password and finish signing up
        </Text>
        <Text
          styledTextProps={{
            fontSize: '19px',
            fontWeight: '400',
          }}
        >
          Your account is ready, except for one thing:
          you still need to set a password. We&apos;ve sent the link to
          {' '}
          <b>{emailAddress}</b>
        </Text>
      </CheckEmailContainer>
    );
  }
  return (
    <FormContainer>
      <TitleArea>
        <img src={Logo} alt='Teambuildr' className='img-fluid' />
        <SubText>Sign In</SubText>
      </TitleArea>
      <FormArea>
        <LoginFormSSO />
      </FormArea>
    </FormContainer>
  );
};

export default LoginFormContainerSSO;
